import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import QrPrintSheet from '../components/QrPrintSheet.jsx';
import { api } from '../services/api.js';

const SHORT = import.meta.env.VITE_SHORT_URL ?? 'https://e.ezbounty.com';

/**
 * Personal-handle QR print page. Fetches the user's profile to get their
 * publicHandle, then renders the shared print sheet with the handle's
 * short URL. No item/bounty — this code covers all of the user's stuff.
 */
export default function PrintHandle() {
  const [handle, setHandle] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.getMe()
      .then((me) => setHandle(me.publicHandle ?? null))
      .catch((e) => setErr(e.message));
  }, []);

  if (err) return <div className="alert error">{err}</div>;
  if (handle === null) return <div className="muted center loading-block">Loading…</div>;

  const url = `${SHORT}/${handle}`;

  return (
    <div className="container-narrow page">
      <div className="print-controls">
        <Link to="/settings" className="muted tiny">← Back to settings</Link>
        <h2 className="mt-12 mb-8">Print your personal code</h2>
        <p className="muted mb-20">
          This code links to all your items. Stick it on a bag, laptop, water
          bottle — anything. A finder scans it to reach you.
        </p>
      </div>
      <QrPrintSheet
        url={url}
        defaultText="Cash reward!"
        filenameBase={`ezbounty-handle-${handle}`}
      />
    </div>
  );
}
